import React from "react";

export default function PaginationControls({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-between items-center mt-6">
      <button
        onClick={() => onPageChange(Math.max(page - 1, 1))}
        className="px-3 py-1 bg-gray-300 text-gray-800 rounded disabled:opacity-50"
        disabled={page === 1}
      >
        Previous
      </button>
      <select
        value={page}
        onChange={(e) => onPageChange(Number(e.target.value))}
        className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {Array.from({ length: totalPages }, (_, index) => index + 1).map((pageNumber) => (
          <option key={pageNumber} value={pageNumber}>
            Page {pageNumber} of {totalPages}
          </option>
        ))}
      </select>
      <button
        onClick={() => onPageChange(Math.min(page + 1, totalPages))}
        className="px-3 py-1 bg-gray-300 text-gray-800 rounded disabled:opacity-50"
        disabled={page === totalPages}
      >
        Next
      </button>
    </div>
  );
}
